<template>
  <label class="textarea__wrap" :disabled="disabled">
    <span class="textarea__text" v-if="title">{{title}}{{ (required) ? '*' : '' }}</span>
    <textarea class="textarea"
              :class="flat ? 'flat' : ''"
              :style="`min-width: ${minWidth}; height: ${inputHeight};`"
              :value="value"
              :placeholder="placeholder"
              :disabled="disabled"
              ref="input"
              @keyup="valueChanged"
              @focus="gotFocus"
              @blur="lostFocus"
              :tabindex="1"
    >
    </textarea>
    <transition name="scaleDown">
            <span v-if="valid.type" class="textarea__valid" :class="'textarea__valid_' + valid.type">
                {{ valid.message }}
                <img v-if=" valid.type === 'error' " src="/img/svg/error_icon.svg" alt="Ошибка" class="textarea__valid__icon">
                <img v-if=" valid.type === 'warning' " src="/img/svg/warning_icon.svg" alt="Внимание" class="textarea__valid__icon">
                <img v-if=" valid.type === 'success' " src="/img/svg/success_icon.svg" alt="Успешно" class="textarea__valid__icon">
            </span>
    </transition>
  </label>
</template>

<script>
export default {
  name: 'app-textarea',
  props: {
    title: String,
    value: String,
    placeholder: String,
    flat: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: '400px'
    },
    inputHeight: {
      type: String,
      default: '170px'
    },
    disabled: Boolean,
    valid: {
      type: Object,
      default () {
        return { message: '', type: null }
      }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    valueChanged () {
      this.$emit('value-changed', this.$refs.input.value)
      this.$refs.input.scrollTop = this.$refs.input.scrollHeight
    },
    gotFocus () {
      this.$emit('got-focus')
    },
    lostFocus () {
      this.$emit('lost-focus')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.textarea {
  width: 100%;
  padding: 10px 15px 10px 15px;
  color: $font_color_second;
  border: 1px solid $color_third-dark;
  border-radius: 3px;
  transition: .3s;
  font: inherit;

  &.flat {
    border: none;
    border-radius: 0;

    &:hover {
      border: none;
    }

    &:focus {
      box-shadow: none;
    }
  }

  &__wrap {
    position: relative;

    &[disabled] {
      pointer-events: none;

      .textarea__text {
        color: $color_deactive;
      }

      .textarea {
        border: 1px solid $color_deactive;
        background-color: $color_deactive-bg;
      }
    }
  }

  &__text {
    color: $font_color_second;
    display: block;
    margin-bottom: 10px;
    font-weight: 600;
  }

  &__valid {
    display: block;
    position: absolute;
    z-index: 99;
    top: auto;
    bottom: auto;
    transform: translateY(-5px) scaleY(1);
    transform-origin: top;
    left: 0;
    width: 100%;
    font-size: 14px;
    padding: 5px 15px 0 15px;
    color: $font_color_alt;
    border-radius: 0 0 3px 3px;
    transition: .3s;

    &__icon {
      position: absolute;
      top: calc(50% - 12.5px);
      left: auto;
      right: -35px;
      animation: fadeIn .3s linear;

      @media screen and (max-width: $tablet_start) {
        display: none;
      }
    }

    &_error {
      background-color: $color_error;
    }

    &_warning {
      background-color: $color_warning;
    }

    &_success {
      background-color: $color_success;
    }
  }

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-button {
    height: 8px;
    opacity: 0;
  }

  &::-webkit-scrollbar-track {
    background: linear-gradient(90deg, $border-color 0%, $border-color 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(90deg, $color_second-light 0%, $color_second-light 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
  }

  &:hover {
    border: 1px solid $color_second-light;
  }

  &:focus {
    box-shadow: inset 0 4px 4px rgba(23, 63, 125, 0.25);
  }
}
</style>
